import(/* webpackMode: "eager" */ "/root/alkindivv.site/app/globals.css");
;
import(/* webpackMode: "eager" */ "/root/alkindivv.site/app/typography.css");
;
import(/* webpackMode: "eager" */ "/root/alkindivv.site/app/animations.css");
;
import(/* webpackMode: "eager" */ "/root/alkindivv.site/app/nprogress.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alkindivv.site/components/layout/HeaderClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alkindivv.site/components/shared/GlowingButtonClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alkindivv.site/components/shared/GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alkindivv.site/components/shared/NavigationEvents.tsx");
;
import(/* webpackMode: "eager" */ "/root/alkindivv.site/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/root/alkindivv.site/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"preload\":true,\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/root/alkindivv.site/node_modules/nprogress/nprogress.css");
